import InternalTransferExportsPage from './InternalTransferExportsPage';

export default InternalTransferExportsPage;
